module.exports = __webpack_public_path__ + "img/crypto-dent-white.4791c325.svg";